<template>
  <div class="tla-form-group tla-form-group--margin-medium" v-if="showConsiderStock">
    <label class="tla-form-group__label tla-form-group__label--required" v-html="considerStockLabel"></label>
    <div v-if="questionLabel">
      <label  class="tla-form-group__label"
        v-html="questionLabel"></label>
    </div>
    <div class="tla-form-group__touch-points">
      <touchpoint v-for="(item) in options"
        :key="item.touchpointValue"
        :collectionName="'considerStock'"
        :inputId="item.touchpointValue"
        :inputValue="item.touchpointValue"
        :isSelected="item.preSelect"
        :isRadioStyle="true"
        :validationScope="validationScope"
        @considerStock="submitConsiderStock($event)">
        <div class="generic-touchpoint__text" slot="touchpoint" v-html="item.touchpointName"></div>
      </touchpoint>
    </div>
    <span class="tla-form-group__message" :class="getValidationClass('considerStock', 'message')">
      Please select an option.
    </span>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { validationService } from '@/services/ValidationService';
import VehicleCondition from '../../enums/VehicleCondition';
import GenericTouchPointComponent from '../ui/GenericTouchPointComponent.vue';
import ExtraData from '../../models/ExtraData';
import Touchpoint from '../../models/Touchpoint';

@Component({
  components: {
  touchpoint: GenericTouchPointComponent
  }
  })
export default class ConsiderVehicleStockComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: false })
  public showIfNewCar!: boolean;

  @Prop({ default: 'Would you consider existing stock? <span>*</span>' })
  public considerStockLabel!: string;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: '' })
  public questionLabel!: string;

  public answer: string = '';

  public options: Touchpoint[] = [
    new Touchpoint('true', 'Yes'),
    new Touchpoint('false', 'No')
  ];

  public get vehicleCondition(): VehicleCondition {
    return this.$store.getters['enquiryModule/vehicleCondition'];
  }

  public get showConsiderStock(): boolean {
    return (this.vehicleCondition === VehicleCondition.New && this.showIfNewCar) || !this.showIfNewCar;
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }

  public submitConsiderStock(value: string) {
    this.answer = value;
    const considerStock = value === 'true';
    this.$store.dispatch('financeModule/submitConsiderStock', considerStock);
  }
}
</script>
